import {
  AnalyticsPeriod,
  CombinedStatistics,
  ContentAnalyticsContentType,
  ContentAnalyticsSortField,
  SortOrder,
  Summary,
} from 'shared/api/requests/analytics/schemas'
import {
  FlowDescriptor,
  IInstagramPost,
  InstagramStory,
} from 'shared/api/requests/instagram/schemas'

export enum AutomationFilter {
  ALL = 'all',
  WITH = 'with',
  WITHOUT = 'without',
}

export interface AnalyticsState {
  query: {
    period: AnalyticsPeriod
    contentType: ContentAnalyticsContentType | null
    automation: AutomationFilter

    sortField: ContentAnalyticsSortField | null
    sortOrder: SortOrder | null
  }
  summary: {
    data: Summary | null
    isLoaded: boolean
    isLoading: boolean
  }
  contentStatistics: {
    list: CombinedStatistics[]
    total: number
    nextPage: number
    isLoaded: boolean
    isLoading: boolean
    isLoadingNextPage: boolean
    isFilterlessFullyLoaded: boolean
  }
  contentDetails: {
    posts: Record<string, IInstagramPost>
    stories: Record<string, InstagramStory>
    isLoaded: boolean
    isLoading: boolean
    useIndividualContentLoading: boolean
    loadingIds: Record<string, true>
    failedIds: Record<string, true>
  }
  contentFlows: {
    flows: Record<string, FlowDescriptor[]>
    isLoaded: boolean
    isLoading: boolean
  }
}

export const AnalyticsInitialState: AnalyticsState = {
  query: {
    period: AnalyticsPeriod.D7,
    contentType: null,
    automation: AutomationFilter.ALL,

    sortField: null,
    sortOrder: null,
  },
  summary: {
    data: null,
    isLoaded: false,
    isLoading: false,
  },
  contentStatistics: {
    list: [],
    total: 0,
    nextPage: -1,
    isLoaded: false,
    isLoading: false,
    isLoadingNextPage: false,
    isFilterlessFullyLoaded: false,
  },
  contentDetails: {
    posts: {},
    stories: {},
    isLoaded: false,
    isLoading: false,
    useIndividualContentLoading: false,
    loadingIds: {},
    failedIds: {},
  },
  contentFlows: {
    flows: {},
    isLoaded: false,
    isLoading: false,
  },
}
